export class TipoAparcamientoModel {

  id: number;
  nombre: string;

  constructor() {
    this.id = null;
    this.nombre = '';
  }
}
